import { Fragment, MutableRefObject, useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import { alertActions } from '../../_actions/alert.actions'
import animation_folder from '../../assets/05_Traverse_Folder_Lock.json';
import Lottie from 'lottie-react';
import { useHistory, useLocation } from 'react-router-dom';
import RegistrationService from '../../services/registration.service';
import { Button } from '@material-ui/core';

type Props = {
    displaySuccessAlert: any,
    displayErrorAlert: any,
    history: any
}

const Registered = (props: Props) => {
    let query = new URLSearchParams(useLocation().search);

    useEffect(() => {
        if (query.get('token')) {
            RegistrationService.verify(query.get('token')!);
        }
    }, [])

    return <Fragment>
        <div className="AppContent">
            <div className="InfoContainer">
                <div className="InfoImage">
                    <Lottie loop={false} animationData={animation_folder} />
                </div>
                <div className="FormContent">
                    <div className="FormTitle">
                        You're almost ready to go, we'll be in touch soon.
                    </div>
                    <div className="FormContent">
                        <div>You’ll recieve a phone call from a Traverse agent to discuss the needs of your business. We’ll reach out to you to help finalize your testing needs.</div>
                        <div className="FormExitButton">
                            <Button
                                onClick={() => {
                                    window.location.href='https://traversecare.com/'
                                }}
                                color="primary"
                            >Close</Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Fragment>
}

const mapState = (state: any) => { return {}; }

const actionCreators = {
    displayErrorAlert: alertActions.error,
    displaySuccessAlert: alertActions.success
};

const connectedApp = connect(mapState, actionCreators)(Registered);

export { connectedApp as Registered };